import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import { getLoading, getShazams } from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByShazams,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-shazams',
    templateUrl: './aggregated-amounts-shazams.component.html',
    styleUrls: ['./aggregated-amounts-shazams.component.scss'],
    standalone: false
})
export class AggregatedAmountsShazamsComponent implements OnInit {
  shazams$: Observable<CountableSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.shazams$ = this.store.select(getShazams)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByShazams)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
